if (!customElements.get('interactive-map-item')) {
  class InteractiveMapItem extends customElements.get('in-view') {
    constructor() {
      super();

      this.arrows = this.querySelectorAll('[data-arrow]');
    }

    connectedCallback() {
      super.connectedCallback();

      this.setArrowsPathLength();
    }

    setArrowsPathLength() {
      this.arrows.forEach((arrow) => {
        const path = this.querySelector('path');

        arrow.style.setProperty('--path-length', path.getTotalLength());
      });
    }
  }

  customElements.define('interactive-map-item', InteractiveMapItem);
}
